var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendario(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508 508",
    style: {
      enableBackground: "new 0 0 508 508"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 254,
    cy: 254,
    r: 254
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M391.6,401.2H116.4c-11.2,0-20-9.2-20-20V126.8c0-11.2,9.2-20,20-20h275.2c11.2,0,20,9.2,20,20v254 C411.6,392,402.8,401.2,391.6,401.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M411.6,168v-41.2c0-11.2-8.8-20-20-20H116.4c-11.2,0-20,8.8-20,20V168H411.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 183.2,
    y: 207.2,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 207.2,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.2,
    y: 207.2,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 207.2,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.4,
    y: 259.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 183.2,
    y: 259.6,
    style: {
      fill: "#4CDBC4"
    },
    width: 31.6,
    height: 31.6
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 259.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.2,
    y: 259.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348,
    y: 259.6,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.4,
    y: 312,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.2,
    y: 312,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 312,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.2,
    y: 312,
    style: {
      fill: "#E6E9EE"
    },
    width: 31.6,
    height: 31.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 343.6,
    cy: 137.2,
    r: 14.4
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 164.4,
    cy: 137.2,
    r: 14.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendario);
export default __webpack_public_path__ + "static/media/calendario.380bbfa874789fe085175dc23efe09ba.svg";
export { ForwardRef as ReactComponent };